import axios from 'axios';
import { deleteData, getData, storeData } from './storage';
import baseURL from '../config/baseURL';
import { getAuthToken } from './auth';
import './http';

export const googleLogInDataStorage = async (access: string, refresh: string) => {

  try {
      const currentDateTime = new Date().toISOString();
      await storeData('access_token', access);
      await storeData('refresh_token', refresh);
      await storeData('access_token_storage_time',currentDateTime);
      await storeData('refresh_token_storage_time',currentDateTime);
      return { success: true, data: 'stored auth data' };
  } catch (error) {
    console.error('An unexpected error occurred:', error);
    return { success: false, data: error };
  }
};

export const logIn = async (email: string, password: string) => {
  const userData = {
    email: email,
    password: password
  };

  try {
    const endpoint = `${baseURL}/auth/jwt/create/`;
    const response = await axios.post(endpoint, userData);
    if (response.status === 200) {
      const currentDateTime = new Date().toISOString();
      await storeData('access_token', response?.data?.access);
      await storeData('refresh_token', response?.data?.refresh);
      await storeData('access_token_storage_time',currentDateTime);
      await storeData('refresh_token_storage_time',currentDateTime);
      return { success: true, data: response?.data };
    } else {
      console.error('Login failed here:', response, response.data);
      return { success: false, data: response?.data };
    }
  } catch (error) {
    console.error('An unexpected error occurred:', error);
    return { success: false, data: error };

  }
};

export const signUp = async (
  full_name: string,
  email: string,
  phone: string,
  address: string,
  password: string,
) => {
  const userData = {
      username: email,
      password: password,
      email: email,
      first_name: full_name,
      last_name: full_name  + " " + phone + " " + address,
  };
  try {
    const endpoint = `${baseURL}/auth/users/`;
    const response = await axios.post(endpoint, userData);

    if (response.status===201) {
      console.log('Sign Up successful! - Sign up request response Data - ', response.data);
      return { success: true, data: response?.data };
    } else {
      console.error('Sign Up failed here:', response, response.data);
      return { success: false, data: response?.data };
    }
  } catch (error) {
    console.error('An unexpected error occurred:', error);
    return { success: false, data: error };
  }
};

export const accountInfo = async () => {
  const token = await getAuthToken();

  if (token.success && token.data) {
    const header_token = 'Bearer ' + token.data;
    const headers = {
      Authorization: header_token,
    };
    try {
      const endpoint = `${baseURL}/auth/users/me/`;
      const response = await axios.get(endpoint,{ headers });
      if (response.status>=200 && response.status <=400) {
        return { success: true, data: response?.data };
      } else {
        console.error('Data retrieval failed here:', response, response.data);
        return { success: false, data: response?.data };
      }
    } catch (error) {
      console.error('An unexpected error occurred:', error);
      return { success: false, data: error };
    }
  }else{
    return { success: false, data: 'error: Token does not exist' };
  }
};

export const setSupplierVerification = async (is_verified:string) => {
  const token = await getAuthToken();
  if (token.success && token.data) {
    await storeData('is_verified', is_verified);
  }else{
    return {"success":false, "data": "error: Token does not exist"};
  }
};

export const getSupplierVerification = async () => {
  const token = await getAuthToken();
  if (token.success && token.data) {
    let is_verified = await getData('is_verified');
    if(is_verified){
      return {"success":true, "data": is_verified};
    } else{
      return {"success":false, "data": is_verified};
    }
  }else{
    return {"success":false, "data": "error: Token does not exist"};
  }
};

export const storeAccountInfo = async () => {
  try{
    let accInfo = await accountInfo();
    if (accInfo.success === true) {
      storeData('email', accInfo.data.email);
      storeData('first_name', accInfo.data.first_name);
    } else {
      return {"success":false, "data": "An error occured"};
    }
  } catch (error) {
    console.error("An unexpected error occurred:", error);
    return {"success":false, "data": error};
  }
}

export const handleSignUp = async (
  full_name: string,
  email: string,
  phone: string,
  address: string,
  password: string,
) => {
  const response = await signUp(full_name, email, phone, address, password);
  
  if (response.success===true) {
    return {"success":true, "data": response?.data};
  } else{
    return {"success":false, "data": response?.data};
  }
}

export const handleLogIn = async (userName:string, password:string) => {
  const response = await logIn(userName, password);
  if (response?.success===true) {
    return { success: true, data: response.data};
  } else {
    return { success: false, data: response.data};
  }
};



export const logOut = async () => {
  await deleteData('is_supplier');
  await deleteData('first_name');
  await deleteData('username');
  await deleteData('logInTime');
  await deleteData('access_token');
  await deleteData('is_verified');
  await deleteData('refresh_token');
  await deleteData('org-data');
  await deleteData('trialInfo');
  await deleteData('orgData');
  await deleteData('subscriptionPlanInfo');
  await deleteData('org-data-selected');
  await deleteData('crm-leads');
  await deleteData('catalogue-items');
  await deleteData('access_token_storage_time');
  await deleteData('refresh_token_storage_time');
  return {"success":true, "data": "Logged out successfully!"};
};
